import React, { useCallback } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import ReactTooltip from 'react-tooltip';
import "../../styles/vote/vote_section.css";
import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { firebaseAuth, firebaseFirestore } from "../firebase/firebase_configuration";
import { getItem } from "../repositories/movies_and_tvseries";

import noImage from "../../images/collections/no_image.png";
import { onAuthStateChanged } from "firebase/auth";

const VoteSection = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [getUserVote, setUserVote] = useState("");
    const [getUserId, setUserId] = useState("");
    const [getTotalVotes, setTotalVotes] = useState(0);
    const [getVoteList, setVoteList] = useState([]);

    const path = location.pathname.split("/");
    const genre = path[path.indexOf("vote") + 1];
    const type = path[path.indexOf("vote") + 2];
    const vowels = ["a", "e", "i", "o", "u"];

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.toLocaleDateString('en-US', {
        month: 'long',
    });
    const date = `${currentMonth.toLowerCase()}_${currentYear}`;

    const genreId = (genre) => {
        const genreMap = {
            thriller: "53",
            mystery: "9648",
            family: "10751",
            horror: "27",
            comedy: "35",
            romance: "10749",
            "science-fiction": "878",
            news: "10763",
            animation: "16",
            drama: "18",
            adventure: "10759",
            kids: "10762",
            reality: "10764",
            soap: "10766",
            talk: "10767",
            western: "37",
            war: "10752",
            documentary: "99",
            history: "36",
            fantasy: "14",
            crime: "80",
            music: "10402",
        };
    
        return genreMap[genre] || "28";
    };

    const goBack = () => {
        navigate(-1);
    };

    const getPercentage = (num) => {
        let dec = num/getTotalVotes;
        return Math.round(dec * 100);
    };

    const getVotedItems = useCallback(async () => {
        try {
            const votedItemsRef = doc(firebaseFirestore, "User Votes", date);
            const unsubscribe = onSnapshot(votedItemsRef, async (voteItemsDocs) => {
                let totalNumberOfVotes = 0;
                let votedItemsSet = [];
                if (voteItemsDocs.exists()) {
                    const votedItemsData = voteItemsDocs.data();
                    Object.keys(votedItemsData).forEach((fieldName) => {
                        const field = votedItemsData[fieldName];
                        Object.entries(field).forEach(([key, value]) => {
                            let exists = false;
                            if (key === `${genre.toLowerCase() === "science-fiction" ? "science fiction" : genre.toLowerCase()}_${type.toLowerCase() === "movies" ? "movie" : "series"}`) {
                                votedItemsSet.forEach((items) => {
                                    if (items.id === value) {
                                        totalNumberOfVotes += 1;
                                        items.vote_num += 1;
                                        exists = true;
                                    }
                                });

                                if (exists === false) {
                                    totalNumberOfVotes += 1;
                                    votedItemsSet.push(
                                        {
                                            id: value,
                                            vote_num: 1
                                        }
                                    )
                                }

                                if (fieldName === getUserId) {
                                    setUserVote(value);
                                }
                            }
                        });
                    });
                };
    
                const updateList = await Promise.all(
                    votedItemsSet.map(async (item) => {
                        const itemId = item.id.split("_")[1];
                        const itemType = item.id.split("_")[0];
                        const details = await getItem({ itemId, type: itemType === "movie" ? itemType : "tv" });
                        return { 
                            ...item, 
                            name: `${itemType === "movie" ? details.title : details.name}`, 
                            image: details.poster_path 
                        };
                    })
                );
    
                setVoteList(updateList);
                setTotalVotes(totalNumberOfVotes);
            });
    
            return() => unsubscribe();
        } catch (error) {
            console.log(error.message);
        };
    }, [date, genre, type, getUserId]);

    useEffect(() => {
        getVotedItems();
    }, [getUserId, getVotedItems]);

    useEffect(() => {
        onAuthStateChanged(firebaseAuth, (user) => {
            if (user) {
                setUserId(user.uid);
            };
        })
    }, []);

    return(
        <div className="vote_section_screen">
            <div className="home_view_discussions_header">
                <p className="vote_section_screen_header">{`${genre === "science-fiction" ? "Science Fiction" : `${genre.charAt(0).toUpperCase()}${genre.slice(1)}`} ${type.charAt(0).toUpperCase()}${type.slice(1)}`}</p>
                <p onClick={goBack} className="home_view_discussions_back">back</p>
            </div>
            <div className="home_view_discussions_divider"></div>
            <div className="vote_section_screen_block">
                <p style={{color: "rgb(165, 165, 165)"}}>Total Votes: {getTotalVotes}</p>
                {
                    getTotalVotes > 0
                    ? getVoteList.map((vote, index) => {
                        let voteName = "";
                        if (vote.id === getUserVote) {
                            voteName = vote.name;
                        }

                        return(<div key={index} className="vote_section_screen_cols">
                            <Link className="action_container_sub_home_screen_b" to={`/main_back/home/${genre.toLowerCase()}/${vote.id.split("_")[0]}/${vote.id.split("_")[1]}`}><div className="vote_section_screen_name_sec">
                                <img alt='img' className="user_search_tab_image" src={vote.image === "" || vote.image == null ? noImage : `https://image.tmdb.org/t/p/w500${vote.image}`} />
                                <p className="vote_section_screen_name_sec_title">{vote.name}</p>
                            </div></Link>
                            <div data-tip data-for={`${getUserVote === vote.id ? "user_vote" : ""}`} id="vote_section_screen_tab" className="vote_section_screen_tab" style={{border: `${getUserVote === vote.id ? "2px solid #FFBF00" : "2px solid #4B9CD3"}`, cursor: `${getUserVote === vote.id ? "pointer" : ""}`}}>
                                <div style={{width: `${getPercentage(vote.vote_num)}%`, backgroundColor: `${getUserVote === vote.id ? "#FFBF00" : "#4B9CD3"}`}} id="vote_section_screen_tab_cov" className="vote_section_screen_tab_cov"></div>
                                <p className="vote_section_screen_tab_percent">{getPercentage(vote.vote_num)}%</p>
                            </div>
                            {
                                getUserVote === vote.id
                                ? <ReactTooltip effect='solid' id="user_vote" place="top">{`You voted for ${voteName}`}</ReactTooltip>
                                : null
                            }
                        </div>)
                    })
                    : <div className="vote_section_screen_no_votes_con">
                        <p className="vote_section_screen_no_votes_text">No votes have been cast in this category 🥲...</p>
                        <Link to={`/main_back/home/${genre}-movies-and-series/${genreId(genre)}`} className="vote_section_screen_link"><p className="vote_section_screen_no_votes_link">Nominate {vowels.includes(genre.charAt(0)) ? "an" : "a"} {genre === "science-fiction" ? "science fiction" : genre} {type === "movies" ? "movie" : "tv series"} for this category.</p></Link>
                    </div>
                }
            </div>
        </div>
    );
};

export default VoteSection;